var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.807,
    height: 30.558,
    viewBox: "0 0 31.807 30.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gas-station-fuel-petroleum",
    transform: "translate(-2.679 -4.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1967",
    "data-name": "Vector 1967",
    d: "M29.143,30.14h6.249a5,5,0,0,0,5-5v-.312A4.687,4.687,0,0,0,35.7,20.141h0a1.562,1.562,0,0,1-1.562-1.562V11.392l6.249-6.249",
    transform: "translate(-6.966 0)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1969",
    "data-name": "Vector 1969",
    d: "M36,15.838h4.375V7.714",
    transform: "translate(-8.824 -0.697)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1964",
    "data-name": "Vector 1964",
    d: "M3.429,10.142V31.39a2.5,2.5,0,0,0,2.5,2.5H19.677a2.5,2.5,0,0,0,2.5-2.5V10.142a5,5,0,0,0-5-5H8.428a5,5,0,0,0-5,5Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1965",
    "data-name": "Vector 1965",
    d: "M22.177,15.429H3.429v7.5H22.177Z",
    transform: "translate(0 -2.787)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2362",
    "data-name": "Vector 2362",
    d: "M10.286,33.429v2.5",
    transform: "translate(-1.858 -7.663)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.5bb5dc162bd8af83c23d9e5f7b539c1a.svg";
export { ForwardRef as ReactComponent };